import { api } from "@/lib/api";

const DAY_MS = 86400000;

export function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

/** Inicio de hoy, de la semana (lunes) y del mes, en la zona horaria del navegador, en segundos Unix. */
export function periodStarts(now = new Date()) {
    const today = startOfDay(now);
    const week = new Date(today);
    week.setDate(today.getDate() - ((today.getDay() + 6) % 7));
    const month = new Date(today.getFullYear(), today.getMonth(), 1);
    return { today: today.getTime() / 1000, week: week.getTime() / 1000, month: month.getTime() / 1000 };
}

export async function fetchStats() {
    const { data } = await api.get("/print/stats", { params: periodStarts() });
    return data; // { today: {labels, pages, jobs}, week: {...}, month: {...} }
}

/** `from` / `to`: fechas "YYYY-MM-DD" (inclusivas) o "". Devuelve { items, total, printed, printers }. */
export async function fetchHistory({ from, to, printer, status, q, limit = 50, offset = 0 }) {
    const params = { limit, offset };
    if (from) params.since = startOfDay(`${from}T00:00:00`).getTime() / 1000;
    if (to) params.until = (startOfDay(`${to}T00:00:00`).getTime() + DAY_MS) / 1000;
    if (printer) params.printer = printer;
    if (status) params.status = status;
    if (q) params.q = q;
    const { data } = await api.get("/print/history", { params });
    return data;
}

const csvCell = (value) => {
    let s = value === null || value === undefined ? "" : String(value);
    // Excel ejecuta como fórmula una celda que empieza con = + - @ (o tabulador/retorno): un título como
    // «=HYPERLINK(…)» se convertiría en un ataque al abrir el CSV. El apóstrofo la deja como texto.
    if (typeof value === "string" && /^[=+\-@\t\r]/.test(s)) s = "'" + s;
    return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** CSV para Excel (separador ";" y BOM, como esperan Excel en español y en portugués). */
export function historyToCsv(items, headers, statusLabel) {
    const rows = [headers, ...items.map((j) => [
        new Date(j.createdAt).toLocaleString("sv-SE"), // 2026-10-06 19:48:00
        j.title || "", j.labels ?? "", j.pages ?? "", j.printer || "", j.agentName || "", statusLabel(j.status),
    ])];
    return "﻿" + rows.map((r) => r.map(csvCell).join(";")).join("\r\n");
}
